export type FormikUnsavedChangesCopy = {
    unsavedChangesTitle?: string;
    unsavedChangesMessage?: string;
    unsavedChangesCancelLabel?: string;
    unsavedChangesContinueWithoutSavingLabel?: string;
};

/** Modal copy when leaving a new/draft form with unsaved input. */
export function getNewRecordUnsavedChangesCopy(recordLabel: string): FormikUnsavedChangesCopy {
    return {
        unsavedChangesTitle: `Discard new ${recordLabel}?`,
        unsavedChangesMessage: `You have started entering a new ${recordLabel} record. If you leave now, your changes will be lost.`,
        unsavedChangesCancelLabel: "Stay",
        unsavedChangesContinueWithoutSavingLabel: "Discard and leave",
    };
}

export type ResolveEditFormUnsavedChangesCopyOptions = {
    isNewRecord?: boolean;
    newRecordLabel?: string;
    /** Explicit overrides; when set, take precedence over new-record defaults. */
    title?: string;
    message?: string;
    cancelLabel?: string;
    continueWithoutSavingLabel?: string;
};

/** Resolves footer unsaved-changes copy for edit vs new-record Formik pages. */
export function resolveEditFormUnsavedChangesCopy(
    options: ResolveEditFormUnsavedChangesCopyOptions
): FormikUnsavedChangesCopy {
    const {
        isNewRecord,
        newRecordLabel,
        title,
        message,
        cancelLabel,
        continueWithoutSavingLabel,
    } = options;

    if (title !== undefined || message !== undefined || continueWithoutSavingLabel !== undefined) {
        return {
            unsavedChangesTitle: title,
            unsavedChangesMessage: message,
            unsavedChangesCancelLabel: cancelLabel ?? "Stay",
            unsavedChangesContinueWithoutSavingLabel: continueWithoutSavingLabel,
        };
    }

    if (isNewRecord && newRecordLabel) {
        return getNewRecordUnsavedChangesCopy(newRecordLabel);
    }

    return {
        unsavedChangesCancelLabel: cancelLabel ?? "Stay",
    };
}
